<script lang="ts">
    import { recordsCitationService } from "../services";
    import { dateInputFormatter } from "../services/Functions";
    import type { RegisterCitation } from "../Model/RegisterCitation";
    import RegisterModalCitation from "./RegisterModalCitation.svelte";
    import FilterRegister from "./FilterRegister.svelte"

    let editRegister = null;

    let registers: any[];
    let offset = 0;
    let limit = 25;
    let searchFilter = {
        register : null,
        selectRegister : null,
        selectType : null,
        date : null
    };
    let startDate = null;
    let endDate = null;
    
    let date = new Date();

    $: loadInputDate()

    async function loadRegisters(searchFilter = null): Promise<void> {
        let opts = {
            offset : offset,
            limit : limit,
            filters : {
                search: searchFilter
            }
        }

        registers = await recordsCitationService.findRegisters(opts);

        registers.sort((a,b) => {
        return a.inRegistNumber < b.inRegistNumber ? -1 : 1;
         })
        
    }

    function loadInputDate() {
        let startMonth = '0'; 
        let month = '0';
        if (date.getMonth() < 10 ) {
            month += date.getMonth()+1;
            startMonth += date.getMonth();
        } else {
            month = `${date.getMonth() + 1}`;
            startMonth = `${date.getMonth()}`;
        }
        let year = date.getFullYear()
        let day = date.getDate()

        startDate = year + '-' + startMonth + '-' + day;
        endDate = year + '-' + month + '-' + day;

        let selectedDates = [startDate, endDate];
        
        searchFilter.selectRegister = 'both';
        searchFilter.date = selectedDates;

        loadRegisters(JSON.stringify(searchFilter));
    }

    function registerUpdate(register: RegisterCitation): void {
        let registerAct = registers.find(u => u.id == register.id)

        if (registerAct) {
            registerAct = register
            registers = registers;
            loadInputDate()
        }else{
            registers = [...registers, register];
        }
    }

</script>

<style>
</style>

<FilterRegister bind:searchFilterComponent={searchFilter} type='citacion' on:load={() => loadRegisters(JSON.stringify(searchFilter))}/>

{#if registers}
    <div class="row mt-3">
        <div class="col-12">
            {#if registers?.length}
            <table class="table">
                <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Entrada</th>
                            <th scope="col">Fecha Entrada</th>
                            <th scope="col">Salida</th>
                            <th scope='col'>Fecha Salida</th>
                            <th scope="col">Tipo</th>
                        </tr>
                </thead>
                <tbody>
                    {#each registers as register, index }
                        <tr>
                            <th scope="row">{index + 1}</th>
                            <td>
                                {#if register.inRegistNumber}
                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                    <span class="btn btn-link" on:click={() => editRegister = register}>
                                        {register.inRegistNumber}
                                    </span>
                                {/if}
                            </td>
                            <td>
                                {#if register.inDate}
                                    {dateInputFormatter(register.inDate)}
                                {/if}
                            </td>
                            <td>
                                {#if register.outRegistNumber}
                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                    <span class="btn btn-link" on:click={() => editRegister = register}>
                                        {register.outRegistNumber}
                                    </span>
                                {/if}
                            </td>
                            <td>
                                {#if register.outDate}
                                    {dateInputFormatter(register.outDate)}
                                {/if}
                            </td>
                            <td>
                                {#if register.contentInfo}
                                    {#if register.contentInfo == 'NULL'}
                                        <span></span>
                                    {:else}
                                        {register.contentInfo}
                                    {/if}
                                {/if}
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </table>
            {:else}
                <div class="text-center pt-5">
                    <hr>
                    <h3>No hay registros para mostrar</h3>
                </div>
            {/if}
        </div>
    </div>
{/if}

<RegisterModalCitation bind:register={editRegister}  on:registerUpdate={() => registerUpdate(editRegister)}/>